// Utility functions for test reporting

export function getStatus(testcase) {
  if (testcase.failure || testcase.error) return 'failed';
  if (testcase.skipped !== undefined) return 'skipped';
  return 'passed';
}

export function getModuleStats(cases) {
  const passed = cases.filter(tc => getStatus(tc) === 'passed').length;
  const failed = cases.filter(tc => getStatus(tc) === 'failed').length;
  const skipped = cases.filter(tc => getStatus(tc) === 'skipped').length;
  const total = cases.length;
  const percent = total > 0 ? Math.round((passed / total) * 100) : 0;
  const duration = cases.reduce((sum, tc) => sum + Number(tc.time || 0), 0);
  return { passed, failed, skipped, total, percent, duration };
}

export function formatDuration(seconds) {
  if (!seconds || isNaN(seconds)) return '0s';
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m > 0 ? m + 'm ' : ''}${s}s`;
}

export function getModuleStatus(cases) {
  // If any failed, status is 'fail', else 'pass'
  return cases.some(tc => getStatus(tc) === 'failed') ? 'fail' : 'pass';
} 